/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

function navbar(theme, ownerState) {
  const { functions, transitions, breakpoints, borders, palette } = theme;
  const { absolute } = ownerState;
  /*  const { background } = palette; */
  const { pxToRem } = functions;
  const { borderRadius } = borders;

  return {
    backdropFilter: absolute ? "none" : `saturate(200%) blur(${pxToRem(30)})`,
    /*  backgroundColor: background.default, */
    top: absolute ? 0 : pxToRem(12),
    minHeight: pxToRem(75),
    display: "grid",
    alignItems: "center",
    borderRadius: borderRadius.xl,
    paddingTop: pxToRem(0),
    paddingBottom: pxToRem(2),
    paddingRight: absolute ? pxToRem(8) : 0,
    paddingLeft: absolute ? pxToRem(16) : 0,

    "& > *": {
      transition: transitions.create("all", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& .MuiToolbar-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      [breakpoints.up("sm")]: {
        minHeight: "auto",
        padding: `${pxToRem(4)} ${pxToRem(16)}`,
      },
    },
  };
}

const navbarContainer = ({ breakpoints }) => ({
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  pt: 0,
  pb: 0,

  [breakpoints.up("md")]: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0",
    paddingBottom: "0",
  },
});

const navbarRow = ({ breakpoints }, { isCollapse }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",

  [breakpoints.up("md")]: {
    justifyContent: isCollapse ? "space-between" : "stretch",
    width: isCollapse ? "100%" : "max-content",
  },
});

function navbarIconButton(theme, ownerState) {
  const { palette, breakpoints } = theme;
  const { darkMode, size } = ownerState;
  const { white, black } = palette;

  return {
    px: 1,

    "& .material-icons, .material-icons-round": {
      fontSize: `${size.xl} !important`,
    },

    "& .MuiTypography-root": {
      display: "none",

      [breakpoints.up("sm")]: {
        display: "inline-block",
        lineHeight: 1.2,
        ml: 0.5,
      },
    },
    "& svg, svg g": {
      color: darkMode ? white.main : black.main,
    },
  };
}

function navbarIconMenu(theme, ownerState) {
  const { palette, breakpoints } = theme;
  const { darkMode, size } = ownerState;
  const { white, black } = palette;

  return {
    px: 1,

    "& .material-icons, .material-icons-round": {
      fontSize: `${size.xl} !important`,
    },

    "& .MuiTypography-root": {
      display: "none",

      [breakpoints.up("sm")]: {
        display: "inline-block",
        lineHeight: 1.2,
        ml: 0.5,
      },
    },
    "& svg, svg g": {
      color: darkMode ? white.main : black.main,
    },
    [breakpoints.up("xl")]: {
      display: "none",
    },
  };
}

const navbarMobileMenu = ({ breakpoints }) => ({
  display: "inline-block",
  lineHeight: 0,

  [breakpoints.up("xl")]: {
    display: "none",
  },
});

export { navbar, navbarContainer, navbarRow, navbarIconButton, navbarIconMenu, navbarMobileMenu };
